/* Position only the decorative payment OR; native checkout controls stay intact. */
if (window.customElements && window.ResizeObserver && !customElements.get('rf-payment-choice-separator')) {
  customElements.define('rf-payment-choice-separator', class extends HTMLElement {
    connectedCallback() {
      this.summary = this.closest('summary');
      this.details = this.closest('details');
      this.row = this.closest('.product-form__buttons');
      this.label = this.summary?.querySelector('.rf-payment-options__label');
      if (!this.summary || !this.label || !this.row) return;
      this.wallet = null;
      this.walletParent = null;
      this.queue = () => {
        if (this.pending) return;
        this.pending = true;
        queueMicrotask(() => {
          this.pending = false;
          this.align();
        });
      };
      this.observer = new ResizeObserver(this.queue);
      [this.summary, this.label, this.details, this.row]
        .forEach(element => this.observer.observe(element));
      this.findWallet();
      this.mutations = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) {
          this.findWallet();
          this.queue();
        }
      });
      this.mutations.observe(this.row, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      for (let parent = this.row.parentElement; parent; parent = parent.parentElement) {
        this.mutations.observe(parent, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
        if (parent.matches('product-info')) break;
      }
      this.details.addEventListener('toggle', this.queue);
      window.addEventListener('resize', this.queue, { passive: true });
      this.queue();
    }

    findWallet() {
      const wallet = this.row.querySelector('.shopify-payment-button shopify-accelerated-checkout');
      if (wallet === this.wallet) return;
      if (this.wallet) {
        this.observer.unobserve(this.wallet);
        if (this.walletParent) this.observer.unobserve(this.walletParent);
      }
      this.wallet = wallet;
      this.walletParent = wallet?.parentElement;
      if (wallet) {
        this.observer.observe(wallet);
        this.observer.observe(this.walletParent);
      }
    }

    align() {
      if (!this.isConnected) return;
      const container = this.row.querySelector('.shopify-payment-button');
      const containerBox = container?.getBoundingClientRect();
      const visible = !!(containerBox?.width && containerBox?.height);
      const visibleValue = String(visible);
      if (this.row.getAttribute('data-rf-payment-wallet-visible') !== visibleValue) {
        this.row.setAttribute('data-rf-payment-wallet-visible', visibleValue);
      }
      const walletBox = this.wallet?.getBoundingClientRect();
      const ready = visible && !!(walletBox?.width && walletBox?.height);
      const readyValue = String(ready);
      if (this.getAttribute('data-rf-wallet-ready') !== readyValue) {
        this.setAttribute('data-rf-wallet-ready', readyValue);
      }
      if (!ready) return;
      const summary = this.summary.getBoundingClientRect();
      const wallet = this.wallet.getBoundingClientRect();
      const label = this.label.getBoundingClientRect();
      if (!summary.width || !wallet.width || !wallet.height || !label.width || !label.height) return;
      const stacked = summary.top >= wallet.bottom - 0.5;
      const centerX = stacked
        ? (wallet.left + wallet.width / 2 + label.left + label.width / 2) / 2
        : (wallet.right + label.left) / 2;
      const centerY = stacked
        ? (wallet.bottom + label.top) / 2
        : (wallet.top + wallet.height / 2 + label.top + label.height / 2) / 2;
      const left = `${(centerX - summary.left - this.summary.clientLeft).toFixed(2)}px`;
      const top = `${(centerY - summary.top - this.summary.clientTop).toFixed(2)}px`;
      if (this.style.getPropertyValue('--rf-payment-or-left') !== left) this.style.setProperty('--rf-payment-or-left', left);
      if (this.style.getPropertyValue('--rf-payment-or-top') !== top) this.style.setProperty('--rf-payment-or-top', top);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mutations?.disconnect();
      this.pending = false;
      this.details?.removeEventListener('toggle', this.queue);
      if (this.queue) window.removeEventListener('resize', this.queue);
    }
  });
}
